import { MiningPatternDocument } from '../MiningPattern/queryBuilder';
import { PassDocument } from '../Passes/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SequenceDocument } from '../Sequences/queryBuilder';
import { SiteDocument } from '../Site/queryBuilder';
import { MiningCutDocument, miningCutPullQueryBuilder } from './queryBuilder';

export function miningCutsFamilyMember(
  configBuilder: ConfigBuilder,
  miningPattern: FamilyMember<MiningPatternDocument>,
  passes: FamilyMember<PassDocument>,
  sequences: FamilyMember<SequenceDocument>,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<MiningCutDocument> {
  const syncConfig = configBuilder<MiningCutDocument>(RxdbCollectionNameV2.MINING_CUTS);
  doNotAutoSync(syncConfig);

  pull(syncConfig, miningCutPullQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.MINING_CUTS, replicationState, [
    miningPattern,
    passes,
    sequences,
    sites,
  ]);
}
